import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import { MessageSquareIcon, UsersIcon, TrendingUpIcon, ArrowRightIcon, XIcon } from 'lucide-react';
const groups = [{
  id: 1,
  name: 'Circular Economy Hub',
  description: "Gruppo dedicato all'economia circolare e alla gestione sostenibile delle risorse.",
  courseImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sMwaciLMqhGLjESiGb7Pkn/IMG_0019.jpg',
  members: 234,
  posts: 156,
  activeMembers: 89,
  courseName: 'Circular Economy Management'
}, {
  id: 2,
  name: 'Space Innovation Network',
  description: 'Community di innovatori e imprenditori nel settore spaziale.',
  courseImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1rN5jawzah89mh82EoFFke/IMG_0009.jpg',
  members: 189,
  posts: 123,
  activeMembers: 67,
  courseName: 'Space Entrepreneurship'
}, {
  id: 3,
  name: 'Sustainability Leaders',
  description: 'Network di professionisti dedicati alla gestione della sostenibilità aziendale.',
  courseImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pir5Kqd16fnaVBRKByB4cH/IMG_0008.jpg',
  members: 312,
  posts: 245,
  activeMembers: 156,
  courseName: 'Management della Sostenibilità'
}];
const GroupsPage = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return <div className="flex h-screen bg-gray-100" data-id="element-1760">
      {/* Mobile sidebar */}
      <div className={`fixed inset-0 z-40 md:hidden ${sidebarOpen ? 'block' : 'hidden'}`} data-id="element-1761">
        {/* Sidebar backdrop */}
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setSidebarOpen(false)} data-id="element-1762"></div>
        {/* Sidebar */}
        <div className="relative flex-1 flex flex-col w-2/3 h-full bg-black" data-id="element-1763">
          <div className="absolute top-0 right-0 -mr-12 pt-2" data-id="element-1764">
            <button type="button" className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" onClick={() => setSidebarOpen(false)} data-id="element-1765">
              <span className="sr-only" data-id="element-1766">Close sidebar</span>
              <XIcon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-1767" />
            </button>
          </div>
          <div className="flex-1 h-full overflow-y-auto" data-id="element-1768">
            <Sidebar activePage="community" data-id="element-1769" />
          </div>
        </div>
      </div>
      {/* Static sidebar for desktop */}
      <div className="hidden md:flex md:flex-shrink-0" data-id="element-1770">
        <Sidebar activePage="community" data-id="element-1771" />
      </div>
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-1772">
        <Topbar onMenuClick={() => setSidebarOpen(true)} data-id="element-1773" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6 pt-0 md:pt-0 bg-gray-100" data-id="element-1774">
          <div className="max-w-6xl mx-auto pt-4 md:pt-6" data-id="element-1775">
            <div className="mb-6" data-id="element-1776">
              <h1 className="text-2xl font-semibold text-gray-800" data-id="element-1777">
                I Miei Gruppi
              </h1>
            </div>
            <div className="space-y-3" data-id="element-1778">
              {groups.map(group => <GroupCard key={group.id} group={group} data-id="element-1779" />)}
            </div>
          </div>
        </main>
      </div>
    </div>;
};
interface GroupCardProps {
  group: {
    id: number;
    name: string;
    description: string;
    courseImage: string;
    members: number;
    posts: number;
    activeMembers: number;
    courseName: string;
  };
}
const GroupCard: React.FC<GroupCardProps> = ({
  group
}) => {
  return <Link to={`/groups/${group.id}`} className="block" data-id="element-1780">
      <div className="bg-white rounded-lg border border-gray-200 hover:border-gray-300 transition-colors" data-id="element-1781">
        <div className="p-4 flex flex-col sm:flex-row" data-id="element-1782">
          <div className="w-full sm:w-[140px] aspect-[4/5] rounded-lg overflow-hidden flex-shrink-0 mb-4 sm:mb-0 sm:mr-4" data-id="element-1783">
            <img src={group.courseImage} alt={group.name} className="w-full h-full object-cover" data-id="element-1784" />
          </div>
          <div className="flex-1" data-id="element-1785">
            <div className="flex items-center justify-between mb-3" data-id="element-1786">
              <div data-id="element-1787">
                <h3 className="text-lg font-semibold text-gray-800" data-id="element-1788">
                  {group.name}
                </h3>
                <p className="text-sm text-gray-500" data-id="element-1789">{group.courseName}</p>
              </div>
              <button className="text-custom-green hover:text-custom-green/90 p-2 rounded-full hover:bg-gray-50 transition-colors" data-id="element-1790">
                <ArrowRightIcon size={20} data-id="element-1791" />
              </button>
            </div>
            <p className="text-sm text-gray-600 mb-4" data-id="element-1792">{group.description}</p>
            <div className="flex flex-wrap items-center gap-4 sm:gap-6" data-id="element-1793">
              <div className="flex items-center text-gray-500" data-id="element-1794">
                <UsersIcon size={16} className="mr-1.5" data-id="element-1795" />
                <span className="text-sm" data-id="element-1796">{group.members} membri</span>
              </div>
              <div className="flex items-center text-gray-500" data-id="element-1797">
                <MessageSquareIcon size={16} className="mr-1.5" data-id="element-1798" />
                <span className="text-sm" data-id="element-1799">{group.posts} post</span>
              </div>
              <div className="flex items-center text-gray-500" data-id="element-1800">
                <TrendingUpIcon size={16} className="mr-1.5" data-id="element-1801" />
                <span className="text-sm" data-id="element-1802">{group.activeMembers} attivi</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>;
};
export default GroupsPage;